import {
  GraphQLGlobalTypes,
  PartialQueryVariables,
  TableRowDataFunctions_getRowDataWithMaxCountsForTable,
  TablesDefaultDirections,
  TablesDefaultSortField,
  TablesDisplayGridRowData,
  TablesExplorerQueryGrid_QueryResultListNode,
  TablesExplorerQueryGrid_QueryResults,
  TablesExplorerQueryGrid_QueryVariables,
  TablesExplorerQueryGrid_selectConnectionListResult,
  TablesQueryGql,
} from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';
import { catalogApolloClient } from '../CatalogApolloClient';
import { BaseGraphQLResourceQuery } from './BaseGraphQLResourceQuery';
import { getSearchFilter } from './CatalogFilterClauseHelpers';
import { getSortOrderOrDefault } from './CatalogOrderClauseHelpers';
import { makeSliceableFactoryForGraphQLQuery } from './GraphQLSliceable';

const getSliceableFactorySingleton = defaultMemoize(() => {
  return makeSliceableFactoryForGraphQLQuery<
    TablesExplorerQueryGrid_QueryResultListNode,
    TablesDisplayGridRowData,
    TablesExplorerQueryGrid_QueryVariables,
    TablesExplorerQueryGrid_QueryResults
    >(
    {
      queryGql: TablesQueryGql,
      selectConnectionListResult: TablesExplorerQueryGrid_selectConnectionListResult,
      mapResultNode: TableRowDataFunctions_getRowDataWithMaxCountsForTable,
    },
    catalogApolloClient
  );
});

export class TablesGraphQLResourceQuery
  extends BaseGraphQLResourceQuery<TablesExplorerQueryGrid_QueryVariables, TablesDisplayGridRowData> {

  public constructor() {
    super(getSliceableFactorySingleton());
  }

  protected getPartialQueryVariables(): PartialQueryVariables<TablesExplorerQueryGrid_QueryVariables> {
    const textSearch = getSearchFilter(this.getFilters());
    const orderBy = getSortOrderOrDefault(this.getOrder(), TablesDefaultSortField, TablesDefaultDirections);
    return { textSearch, orderBy: orderBy as GraphQLGlobalTypes.DatabaseTableSortOrder };
  }
}
